import './treatmentItem.scss'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { addressToString } from '../../../../../../types/types'
import { useProductOrderContext } from 'components/product-order-popup/context'
import { type CartItem, type OrderInfo } from 'types/products/productTypes'

type Props = {
  orderItem: OrderInfo | CartItem
}
export const TreatmentItem = ({ orderItem }: Props) => {
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const { deliveryType, isMoudPharmacyPickup, isMHTPharmacyPickup } = useProductOrderContext()
  const isPharmacyPickup = isMHTPharmacyPickup || isMoudPharmacyPickup

  if (!orderItem?.Order) {
    return null
  }

  return (
    <div className='treatment-item-container'>
      <div className='treatment-item-info-container'>
        <div>
          {`Treatment - ${orderItem.Order.Name}${isPharmacyPickup ? ` - ${orderItem.Order.ShortName}` : ''}`}
          {isPharmacyPickup ? <>
              <div className='treatment-item-info-sub-line'>
                {/*
                 // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered */}
                Order quantity: {Math.ceil(orderItem.DispenseAmount)} {orderItem.Order.DispenseUnits}s
              </div>
              <div className='treatment-item-info-sub-line'>Sig: {orderItem.Signature}</div>
            </> : null}
        </div>

        <div>{`$${orderItem.Order.Price.toFixed(2)}`}</div>
      </div>

      {/* deliveryType === 'home' ? (
        <>
          <div className="treatment-item-shipping-text">Shipping to:</div>

          <div className="treatment-item-shipping-text">{addressToString(orderItem.Address)}</div>
        </>
      ) : null */}
    </div>
  )
}
